import useEmblaCarousel from 'embla-carousel-react';
import { useCallback, useEffect, useState } from 'react';

export function useTestimonialsDesktopSlider() {
  const active = true;
  const [canScrollPrev, setCanScrollPrev] = useState(false);
  const [canScrollNext, setCanScrollNext] = useState(false);

  const [emblaRef, emblaApi] = useEmblaCarousel({
    active,
    slidesToScroll: 1,
    align: 'start',
    // With loop true slider as style issue, when last slide is not visible at the left of first slide
    loop: false,
    containScroll: 'trimSnaps'
  });

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setCanScrollPrev(emblaApi.canScrollPrev());
    setCanScrollNext(emblaApi.canScrollNext());
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
    onSelect();
    emblaApi.on('select', onSelect);
    emblaApi.on('reInit', onSelect);
  }, [emblaApi, onSelect]);

  return {
    ref: emblaRef,
    active,
    scrollPrev: canScrollPrev && emblaApi?.scrollPrev,
    scrollNext: canScrollNext && emblaApi?.scrollNext
  };
}
